import React from "react";
import { ShieldWarning, WhatsappLogo, SignOut } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../lib/i18n";

const WHATSAPP_NUMBER = "5511940070663";

export default function Blocked() {
  const { t } = useI18n();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const message = encodeURIComponent("Olá, meu acesso ao LEXADM foi bloqueado. Poderia me ajudar?");
  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-navy text-white flex flex-col items-center justify-center px-6 py-12 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)",
          backgroundSize: "30px 30px",
        }}
      />
      <div
        className="absolute -top-24 left-1/2 -translate-x-1/2 w-96 h-96 rounded-full"
        style={{ background: "radial-gradient(circle,rgba(214,40,40,0.16),transparent 70%)" }}
      />

      <div className="relative w-full max-w-lg text-center animate-fade-up">
        <div className="flex justify-center mb-8">
          <Logo variant="dark" size="lg" />
        </div>

        <span className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-risk-critical/15 border border-risk-critical/30 mb-6">
          <ShieldWarning size={40} weight="fill" color="#E76F51" />
        </span>

        <p className="label-caps text-risk-high mb-3" data-testid="blocked-badge">
          {t("blocked.badge")}
        </p>
        <h1 className="font-display font-bold text-3xl sm:text-4xl leading-tight" data-testid="blocked-title">
          {t("blocked.title")}
        </h1>
        <p className="text-sm sm:text-base text-slate-300 leading-relaxed mt-5 max-w-md mx-auto">
          {t("blocked.body")}
        </p>

        <a
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-link"
          className="mt-9 inline-flex items-center justify-center gap-2.5 bg-[#25D366] text-navy font-bold rounded-md px-7 py-3.5 hover:brightness-105 transition-all duration-200 shadow-[0_10px_30px_-10px_rgba(37,211,102,0.5)]"
        >
          <WhatsappLogo size={22} weight="fill" />
          {t("blocked.whatsapp")}
        </a>

        <div className="mt-6">
          <button
            onClick={handleLogout}
            data-testid="blocked-logout"
            className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors"
          >
            <SignOut size={16} />
            {t("blocked.logout")}
          </button>
        </div>

        <p className="mt-12 text-xs text-slate-500">{t("blocked.footer")}</p>
      </div>
    </div>
  );
}
